import { FC, useState } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import { IActive } from '../config';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { EfModal } from '@/components/UI';
import { ModalIcon, ModalCloseIcon } from '@/components/EcoCredits/Svg';
import EfImg from '@elem/ui/ef-img';
import getLocal from '@/app/utils/getLocal';

interface IBenefitsMessageProps {
    active: IActive;
}

const imgConfig: Record<string, string> = {
    us: 'https://websiteoss.ecoflow.com/upload/image/1723545703531/en.png',
    de: 'https://websiteoss.ecoflow.com/upload/image/1723545714864/de.png',
    fr: 'https://websiteoss.ecoflow.com/upload/image/1723545725341/fr.png',
    it: 'https://websiteoss.ecoflow.com/upload/image/1723545735475/it.png',
    es: 'https://websiteoss.ecoflow.com/upload/image/1723545748089/es.png',
    kr: 'https://websiteoss.ecoflow.com/upload/image/1723545757688/kr.png',
};

const BenefitsMessage: FC<IBenefitsMessageProps> = ({ active }) => {
    const { t } = useLang('ecocredits.ecoflowbenefits');
    const { locale } = getLocal();
    const [visible, setVisible] = useState(false);

    const messageObject: Record<IActive, string> = {
        savings: t.rich('ecoflowbenefits_savings_message', {
            line: (text: string) => (
                <span className="here" onClick={() => setVisible(true)}>
                    {text}
                </span>
            ),
        }),
        support: t.rich('ecoflowbenefits_support_message', {
            email: (email: string) => (
                <a className="here" href={`mailto:${email}`} rel="noreferrer">
                    {email}
                </a>
            ),
        }),
        experiences: t('ecoflowbenefits_experiences_message'),
    };

    return (
        <div className={styled.BenefitsMessage}>
            <p className="benefits-message">{messageObject[active]}</p>

            <EfModal className={styled.BenefitsModal} visible={visible} onCancel={() => setVisible(false)} zIndex={1200}>
                <div className="modal-body">
                    <div className="header">
                        <ModalIcon />
                        <ModalCloseIcon onClick={() => setVisible(false)} />
                    </div>
                    <div className="content-bg">
                        <div className="content">
                            <p>{t('ecoflowbenefits_savings_message_pop1')}</p>
                            <p>
                                {t('ecoflowbenefits_savings_message_pop2')}
                                <div className="img">
                                    <EfImg pc={imgConfig[locale] || imgConfig.us} />
                                </div>
                            </p>

                            <p>{t('ecoflowbenefits_savings_message_pop3')}</p>
                        </div>
                    </div>
                </div>
            </EfModal>
        </div>
    );
};

export default BenefitsMessage;
